/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoggerService } from '../../shared/services/logger.service';
import { CriteriaFormComponent } from './criteria-form.component';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, take } from 'rxjs/operators';
import { SearchListEntry } from '../state/search.model';
import { SearchCriteriaContainerComponent } from './search-criteria-container.component';
import { Store } from '@ngxs/store';
import { UntypedFormBuilder } from '@angular/forms';
import { SetSearchParams } from '../state/search.actions';

@Component({
    selector: 'dash-gis-search-criteria-dialog',
    templateUrl: './search-criteria-dialog.component.html',
    styleUrls: [ './search-criteria-dialog.component.scss' ],
})
export class SearchCriteriaDialogComponent
    extends SearchCriteriaContainerComponent implements OnInit {

    @Output() public back: EventEmitter<any> = new EventEmitter();

    @ViewChild(CriteriaFormComponent)
    public criteriaForm: CriteriaFormComponent;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<SearchCriteriaDialogComponent>,
        logger: LoggerService,
        fb: UntypedFormBuilder,
        store: Store,
    ) {
        super(logger, fb, store);
        this.search$ = this._search$.pipe(map(fn => fn(this.instanceId)));
        this.criteria$ = this._criteria$.pipe(map(fn => fn(this.instanceId)));
    }

    public ngOnInit() {
        this.criteria$.pipe(
            take(1)
        ).subscribe((criteria) => {
            this.setupFormGroup(criteria);
        });
    }

    public search() {
        this.store.dispatch(new SetSearchParams({
            instanceId: this.instanceId,
            params: this.criteriaForm.criteriaFormGroup.value,
        }));
        this.dialog.close({
            name: this.searchName$,
            params: this.criteriaForm.criteriaFormGroup.value,
        });
    }

    public cancel() {
        this.dialog.close();
    }

    get instanceId() {
        return this.data.id;
    }

    get searchName$(): Observable<string> {
        return this.search$.pipe(
            map((definition: SearchListEntry) => definition.name),
            distinctUntilChanged(),
        );
    }

    get searchDisplayName$(): Observable<string> {
        return this.search$.pipe(
            map((definition: SearchListEntry) => definition.displayName),
            distinctUntilChanged(),
        );
    }
}
